import * as yup from "yup";
import { CUSTOMER_NOTE_TEXT_LENGTH_LIMIT } from "config/customer";

const schema = yup.object().shape({
  customerNote: yup.string().trim().max(CUSTOMER_NOTE_TEXT_LENGTH_LIMIT, "customerDetail.customerNote.error.max"),
});

export default schema;
